import React from 'react'
import { Form } from 'react-bootstrap'
import Button from '../UI/button'
import SvgIcon from '../SVG/svg'
import Calendar from '../UI/calendar'

type Props = {}

const ThInputsDate = (props: Props) => {
	const [showCalendar, setShowCalendar] = React.useState<boolean>(false)

	return (
		<Form.Group className='th-inputs-date position-relative'>
			<Form.Control type='number' placeholder='Month' />
			<Form.Control type='number' placeholder='Day' />
			<Form.Control type='number' placeholder='Year' />
			<Button onClick={() => setShowCalendar(!showCalendar)} className='p-0' variant='transparent'>
				<SvgIcon type='calendar' fill='#842234' />
			</Button>
			<Calendar show={showCalendar} />
		</Form.Group>
	)
}
export default ThInputsDate